// New Page for cabin information
import React, { useRef, useState } from 'react';

import { timeConvert } from '../utilities/helperfunctions';
import { DISABLE_SWIPE } from '../utilities/enums';
import { useOverflowObserver } from '../helpers';

export function CabinPage(props) {
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const [isSwipeDisabled, setIsSwipeDisabled] = useState(false);

  useOverflowObserver(containerRef, contentRef, setIsSwipeDisabled);
  // Formatting strings from data

  const tripTime = props.data?.dbTripFuelDur_H
    ? timeConvert(props.data.dbTripFuelDur_H)
    : 'N/A';

  let paxData = props.data?.sPax?.[0]
    ? props.data.sPax[0].split('Pax figures:')
    : 'N/A';

  let cif = props.cifData ? props.cifData + '' : '';

  // Meal map needs to be separated from the rest of the text as its too large to fit normally
  // If there is no meal map (or no cif data), the text will be displayed as an empty string (see line 43)
  const cifTextSplit = cif.split('Meal map:');

  const csm = cif.match(/CSMPOST|CSMPRE/)?.[0];
  const msgTime = cif.match(/Msg Time:[^\n]+/)?.[0];

  return (
    <div
      ref={containerRef}
      className={`cabincrew-page-container ${
        isSwipeDisabled ? DISABLE_SWIPE : ''
      }`}
    >
      <div className='date-time-pax-column'>
        <p style={{ color: '#D81939', fontWeight: 'bold' }}>
          For better readability, use horizontal mode
        </p>
        <p>TRIP TIME: {tripTime}</p>
        <p>PAX: {paxData} </p>
      </div>
      {/* {props.data && <GeneralInfoCabin data={props.data} />} */}
      <div
        className={`altea-highlight ${
          csm === 'CSMPOST' ? 'altea-highlight-green' : 'altea-highlight-red'
        }`}
      >
        {csm && <p>ALTEA {csm}</p>}
        <p>{msgTime}</p>
      </div>
      <div ref={contentRef} style={{ width: 'fit-content' }}>
        <pre className='cif-text'> {cifTextSplit[0]} </pre>
      <pre style={{ fontSize: 11 }}>
        {' '}
        {cif === 'No CIF data found' ||
        cifTextSplit[1] === undefined ||
        cifTextSplit[1] === ''
          ? ''
          : 'Meal map: '}{' '}
        {cifTextSplit[1]}
      </pre>
    </div>
    </div>
  );
}
